export const MEDICAL_KEYS = ["general", "cardiovascular", "injuries", "treatment"] as const;
export type MedicalKey = typeof MEDICAL_KEYS[number];
export type MedicalAnswers = Record<MedicalKey, { answer: boolean | null; details: string }>;
export const emptyMedicalAnswers = (): MedicalAnswers => ({
  general: { answer: null, details: "" },
  cardiovascular: { answer: null, details: "" },
  injuries: { answer: null, details: "" },
  treatment: { answer: null, details: "" },
});

/** Keep the existing server-validated safety field and staff notes contract.
 * Line breaks inside a detail are stored as LINE_BREAK_MARK so each answer stays on one notes line.
 */
export const MEDICAL_DETAILS_MAX = 500;
export const LINE_BREAK_MARK = " ↵ ";
const encodeDetails = (value: string) => value.trim().replace(/\r/g, "").split("\n").map(l => l.trim()).filter(Boolean).join(LINE_BREAK_MARK);
export function buildTrialSafetyDetails(emergencyPhone: string, medical: MedicalAnswers): string {
  return [
    `Emergency phone: ${emergencyPhone.trim()}`,
    ...MEDICAL_KEYS.map(key => `${key}: ${medical[key].answer ? "Yes" : "No"}${medical[key].answer && medical[key].details.trim() ? ` — ${encodeDetails(medical[key].details)}` : ""}`),
  ].join("\n");
}

export function hasMedicalAnswers(medical: MedicalAnswers): boolean {
  return MEDICAL_KEYS.every(key => medical[key].answer !== null);
}